<template>
  <div class="custCredMain">
    <div class="custCredTop">
      <div class="custCredSection" style="margin: 0 5px 0 0;">
        <InputQuery :isDisabled="viewMode" placeholder="Credit Controller" :items="data.CreditControllerData" itemKey="EmployeeID" descKey="Employee Name" :selectedObject.sync="data.selectedCreditController" />
        <Input :isDisabled="viewMode" placeholder="Credit Limit" :inputValue.sync="data.CreditLimit" />
        <Input :isDisabled="viewMode" placeholder="Credit Term" :inputValue.sync="data.CreditTerm" />
        <InputQuery :isDisabled="viewMode" placeholder="Credit Type" :items="data.CreditTypeData" descKey="Description" :selectedObject.sync="data.selectedCreditType" />
        <Input :isDisabled="viewMode" placeholder="Credit Rating" :inputValue.sync="data.CrRating" />
        <Input :isDisabled="viewMode" placeholder="Overdraft Ammount" :inputValue.sync="data.cu_overpay" />
        <Input :isDisabled="viewMode" placeholder="Cash Float Ammount" :inputValue.sync="data.cu_floatamt" />
        <Input placeholder="Current Outstanding" isDisabled="true" :inputValue.sync="data.CurrentOutStanding" />
      </div>
      <div class="custCredSection" style="margin: 0 0 0 5px;">
        <div class="custCredExtend">
          <div class="custCredExtendTitle">Extended Credit</div>
          <InputQuery :isDisabled="viewMode" placeholder="Approved By" :items="data.ApprovedByData" itemKey="EmployeeID" descKey="Employee Name" :selectedObject.sync="data.selectedApprovedBy" />
          <Input :isDisabled="viewMode" placeholder="Extended Credit Limit" :inputValue.sync="data.ExtCreditLimit" />
          <Input :isDisabled="viewMode" placeholder="Extended Credit Term" :inputValue.sync="data.ExtCreditTerm" />
          <Input :isDisabled="viewMode" placeholder="Extended Credit Type" :inputValue.sync="data.ExtCreditType" />
          <div class="rowBox" style="align-items: flex-end;">
            <div class="custCredExtendDate">
              <DateTime :isDisabled="viewMode" title="Valid From" :value.sync="data.ValidFr" />
              <DateTime :isDisabled="viewMode" title="Valid To" :value.sync="data.ValidTo" />
            </div>
            <button style="margin: 0 0 0 20px;">Extended Credit</button>
          </div>
        </div>
      </div>
    </div>
    <div class="custCredTabulatorMain">
      <Tabulator class="custCredTabulator" tableTitle="Extended Credit History" tableID="cu_credit" :tableData="data.AuditExtendedCreditData" />
    </div>
  </div>

  <!--credController: [],
  credLimit: '',
  credTerm: '',
  credType: [],
  credRating: '',
  credOverdraft: '',
  credCashFloat: '',
  credCurrentOutstanding: '',
  credApprovedBy: [],
  credExtendLimit: '',
  credExtendTerm: '',
  credExtendType: '',
  credFrom: '',
  credTo: '',-->
</template>

<script>
/* eslint-disable */
import Input from '@/components/Input.vue';
import DateTime from '@/components/DateTimePicker.vue';
import InputQuery from '@/components/InputQuery.vue';
import Dropdown from '@/components/Dropdown.vue';
import Address from '@/components/AddressForm.vue';
import Checkbox from '@/components/CheckBox.vue';
import Tabulator from '@/components/Tabulator.vue';

export default {
  components: {
    Input, DateTime, InputQuery, Dropdown, Address, Checkbox, Tabulator
  },
  props: {
    viewMode: { type: Boolean, default: false },
    data: { type: Object, default: function() { return {} } },
  },
  mounted() {

  },
  methods: {

  },
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

  .custCredMain {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }

  .custCredTop {
    width: 100%;
    height: auto;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }

  .custCredSection {
    flex: 1;
  }

  .custCredExtend {
    padding: 10px 5px 5px 5px;
    margin: 15px 5px 5px 5px;
    position: relative;
    border: solid 1px #00000033;
    border-radius: 3px;
  }

  .custCredExtendTitle {
    width: auto;
    height: 20px;
    padding: 0 5px 0 5px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    top: -11px;
    left: 10px;
    position: absolute;
    background-color: #ffffffff;
  }

  .rowBox {
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .custCredTabulatorMain {
    width: 100%;
    flex: 1;
  }

  .custCredTabulator {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

</style>